import { backgroundTransitionOnClick, flex, IconFont, pointer, wideSpreadAnimation } from '@byecode/ui'
import styled from 'styled-components'

export const Icon = styled(IconFont)<{ size?: number; color?: string; bgColor?: string; cursor?: string }>`
    font-size: ${({ size }) => size ?? 16}px;
    color: ${({ color }) => color ?? 'var(--color-gray-400)'};
    cursor: ${({ cursor }) => cursor ?? 'pointer'};
`

export const SquareIcon = styled(IconFont)<{ size?: number; color?: string; bgColor?: string }>`
    padding: 6px;
    font-size: ${({ size }) => size ?? 16}px;
    color: ${({ color }) => color ?? 'var(--color-black)'};
    background: ${({ bgColor }) => bgColor ?? 'var(--color-white)'};
    border-radius: 6px;
`

export const Text = styled.span<{ color?: string }>`
    font-size: var(--font-size-normal);
    color: ${({ color }) => color ?? 'var(--color-black)'};
    line-height: 16px;
    ${pointer}
`

export const Title = styled.div`
    width: 100%;
    padding: 12px 16px;
    font-style: normal;
    font-weight: 600;
    font-size: var(--font-size-base);
    line-height: 24px;
    color: var(--color-black);
`
